import { render } from "./IconSignature.vue?vue&type=template&id=6c0b0ee5"
import script from "./IconSignature.vue?vue&type=script&lang=ts"
export * from "./IconSignature.vue?vue&type=script&lang=ts"
script.render = render

export default script